NtechApp.FormManager = function(cb) {
    var me = this;

    me._click = new NtechApp.TouchClickEvent();
    me._formSelects = [];
    me._formRadios = [];
    me._formSerializedCheckboxes = [];
    me._singleFileUploaders = [];

    me._bindFormSwitchers();
    me._bindFormErrors();
    me._bindFormSelects();
    me._bindFormRadios();
    me._bindFormSerializedCheckboxes();
    me._bindFormPhones();
    me._bindSingleFileUploaders();

    return this;
};

NtechApp.FormManager.EVENT_FORM_SWITCH = "NtechApp.FormManager.EventFormSwitch";

NtechApp.proto(NtechApp.FormManager, {
    _bindFormSwitchers: function() {
        var me = this;
        $.each($("body").find("[data-switchableForm]"), function() {
            me._bindSwitchableFormEvents($(this));
        });
    },

    // @todo -> pass formRoot and subformRoot params
    // (Ensure this is required, switch targets are global(from other forms))
    // @todo -> Add multiple switcher event support
    switchToForm: function(formName, subformName) {
        var $form = $("body").find("[data-switchTo='" + formName + "']");
        $form.trigger("click");

        if(typeof subformName != "undefined") {
            var $subform = $("body").find("[data-switchToSub='" + subformName + "']");
            $subform.trigger("click");
        }
    },

    _bindSwitchableFormEvents: function($form) {
        var me = this;
        var selectItem = function($form, e, to, target) {
            var $switchTo = $(e.target);
            if($switchTo.hasClass("selected"))
                return;

            $switchTo.parent().find("[" + to + "]").removeClass("selected");
            $switchTo.addClass("selected");

            var switchTo = $switchTo.attr(to);

            $form.find("[" + target + "]").css("display", "none");
            $form.find("[" + target + "=" + switchTo + "]").css("display", "block");

            $(me).trigger(NtechApp.FormManager.EVENT_FORM_SWITCH);
        };

        me._click.listen($form, "[data-switchTo]", function(e) {
            selectItem($form, e, "data-switchTo", "data-switchTarget");
        });
        me._click.listen($form, "[data-switchToSub]", function(e) {
            var $item = $(e.target).closest("[data-switchTarget]");
            selectItem($item, e, "data-switchToSub", "data-switchSubTarget");
        });
    },

    _bindFormErrors: function() {
        var me = this;
        $.each($("body").find("[data-formErrorsManager]"), function() {
            (function($formErrors) {
                me._click.listen($formErrors, function() {
                    $formErrors.css("display", "none");
                });
            })($(this));
        });
    },

    _bindFormSelects: function() {
        var me = this;
        $.each($("body").find("[data-customSelectId]"), function() {
            me._createFormSelect($(this));
        });
    },

    _createFormSelect: function($selectTextInput) {
        var formSelect = new NtechApp.SelectForm(
            $selectTextInput
        );
        this._formSelects.push(formSelect);

        this._click.listen(formSelect.getView(), function() {
            formSelect.on();
        });
    },

    bindFormSelect: function($selectTextInput) {
        this._createFormSelect($selectTextInput);
    },

    getFormSelectById: function(id) {
        for(var i = 0; i < this._formSelects.length; i++) {
            if(this._formSelects[i].getSelectInput().attr("data-customselectid") == id)
                return this._formSelects[i];
        }
    },

    _bindFormRadios: function() {
        var me = this;
        $.each($("body").find("[data-customRadioId]"), function() {
            me._createFormRadio($(this));
        });
    },

    _createFormRadio: function($radioWrapper) {
        var radioBox = new NtechApp.RadioBox(
            $radioWrapper
        );
        this._formRadios.push(radioBox);
    },

    bindFormRadio: function($radioWrapper) {
        this._createFormRadio($radioWrapper);
    },

    getRadioBoxById: function(id) {
        for(var i = 0; i < this._formRadios.length; i++) {
            if(this._formRadios[i].getRadioWrapper().attr("data-customradioid") == id)
                return this._formRadios[i];
        }
    },

    _bindFormSerializedCheckboxes: function() {
        var me = this;
        $.each($("body").find("[data-customSerializedCheckboxesId]"), function() {
            me._createFormSerializedCheckboxes($(this));
        });
    },

    _createFormSerializedCheckboxes: function($checkboxesWrapper) {
        var serializedCheckboxes = new NtechApp.SerializedCheckboxes(
            $checkboxesWrapper
        );
        this._formSerializedCheckboxes.push(serializedCheckboxes);
    },

    getSerializedCheckboxById: function(id) {
        for(var i = 0; i < this._formSerializedCheckboxes.length; i++) {
            if(this._formSerializedCheckboxes[i].getCheckboxWrapper().attr("data-customSerializedCheckboxesId") == id)
                return this._formSerializedCheckboxes[i];
        }
    },

    _bindFormPhones: function() {
        var me = this;
        $.each($("body").find("[data-phoneCustomInput]"), function() {
            me._createPhoneInput($(this));
        });
    },

    bindFormPhones: function($phoneInput) {
        this._createPhoneInput($phoneInput);
    },

    _createPhoneInput: function($phoneInput) {
        var me = this;

        var origVal = $phoneInput.val();
        if(origVal.length > 0)
            $phoneInput.val(me.formatPhoneVal($phoneInput));

        $phoneInput.on("input", function() {
            $phoneInput.val(me.formatPhoneVal($phoneInput));
        });
        $phoneInput.on("paste", function() {
            setTimeout(function() {
                var val = me.formatPhoneVal($phoneInput);
                val = val.substr(0, $phoneInput.attr("maxlength"));
                $phoneInput.val(val);
            }, 20);
        });
    },

    formatPhoneVal: function($phoneInput, valAttr) {
        var valCustomAttr = valAttr || false;

        var digitChar = "#";
        var format = $phoneInput.attr("data-phoneFormat");

        if(valCustomAttr !== false)
            var val = $phoneInput.attr(valCustomAttr);
        else
            var val = $phoneInput.val();
        var cleanVal = val.replace(/[^\d]/g, '');

        var formattedVal = "";
        for(var i = 0; i < cleanVal.length; i++) {
            if(format.length > 0) {
                while(format[0] != digitChar) {
                    formattedVal += format[0];
                    format = format.substr(1, format.length - 1);
                }

                formattedVal += cleanVal[i];
                format = format.substr(1, format.length - 1);
            }
            else {
                formattedVal += cleanVal[i];
            }
        }

        return formattedVal;
    },

    _bindSingleFileUploaders: function() {
        var me = this;
        $.each($("body").find("[data-singleFileUploader]"), function() {
            me._createSingleFileUploader($(this));
        });
    },

    _createSingleFileUploader: function($uploaderTrigger) {
        var id = $uploaderTrigger.attr("data-singleFileUploader");

        var uploader = new NtechApp.FormSingleFileUploader(
            $uploaderTrigger,
            $uploaderTrigger.closest("form").find("[data-singleFileHiddenId='" + id + "']"),
            $uploaderTrigger.closest("form").find("[data-singleFileUploaderInfo='" + id + "']"),
            $uploaderTrigger.closest("form").find("[data-singleFileUploaderImage='" + id + "']")
        );
        this._singleFileUploaders.push(uploader);
    },

    bindSingleFieldUploader: function($uploaderTrigger) {
        this._createSingleFileUploader($uploaderTrigger);
    }
});